import React from 'react';

import styled from 'styled-components';

import { Color } from '@assets/constants';
import { icons } from '@assets/icons';
import { ReactComponent as Logo } from '@assets/images/logo-horizontal.svg';
import { OrdersTable } from '@features/tables/OrdersTable';
import { useCustomNavigate } from '@hooks';
import { useOrders } from '@queries';

export const OrdersContainer = () => {
  const navigate = useCustomNavigate();
  const { data: orders, isPending } = useOrders();

  return (
    <Wrapper>
      <Header>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
      </Header>
      <TableWrapper>
        <BackButton onClick={() => navigate('/admin-panel')}>
          <icons.FaChevronLeft />
          <p>Back to Admin Panel</p>
        </BackButton>
        <OrdersTable orders={orders} isLoading={isPending} />
      </TableWrapper>
    </Wrapper>
  );
};

const BackButton = styled.p`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
  color: ${Color.DARK_GRAY};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const LogoWrapper = styled.div`
  width: 300px;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 24px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background: ${Color.GRAY};
  min-height: 100svh;
  width: 100svw;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;
